import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import InvoiceForm from '../../components/Factures/InvoiceForm';

const NewInvoicePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fromPayments, selectedPayments } = location.state || {};

  return (
    <InvoiceForm 
      onSave={(invoice) => {
        // Navigate back to invoices list or to the new invoice detail
        navigate(`/ventes/factures`);
      }}
      onCancel={() => {
        // Navigate back to payments list or invoices list
        navigate(fromPayments ? '/reglements' : '/factures');
      }}
      fromPayments={fromPayments}
      selectedPayments={selectedPayments || []}
    />
  );
};

export default NewInvoicePage;
